<div class="container">
    <img
        alt="Guitar pick"
        class="guitarPick"
        src="../../assets/guitarPick.svg"
    />

    <div class="wrapper">
        <!-- HEADER -->
        <div class="headerContainer">
            <div class="logoWrapper">
                <img
                    class="controlant-logo"
                    src="../../assets/controlant-logo-color.svg"
                />
            </div>
        </div>

            <!-- CONTENT -->
            <div class="contentContainer">
                <div class="contentHeader">
                    <div class="title-username">
                        <h4 i18n="Request password reset headline@@resetPasswordHeadline">New Password</h4>
                        <h3 class="subHeader username">{{ username }}</h3>
                    </div>
                    <div class="subHeader errorStyles">
                        <p *ngIf="error === 'NO_TOKEN'"
                           i18n="Invalid or no token error@@errorPasswordTokenMissing">Invalid or No token provided in URL. Please
                            copy the link you received by e-mail into the address bar of your browser manually and try again.</p>
                        <p *ngIf="error === 'PASSWORD_MISSING'"
                           i18n="Missing password error@@errorPasswordMissing">Please enter a password.</p>
                        <p *ngIf="error === 'PASSWORD_TOO_SHORT'"
                           i18n="Password too short error@@errorPasswordTooShort">Password is too short (minimum 6 letters).</p>
                        <p *ngIf="error === 'PASSWORDS_DONT_MATCH'"
                           i18n="Passwords don't match error@@errorPasswordsNonMatching">The two password fields do not match.</p>

                        <p *ngIf="error === 'CONTROLANT_API_ERROR_80'"
                           i18n="Password reset isn't active error@@errorPasswordResetNotActive">No password reset is currently
                            active for the username provided.</p>
                        <p *ngIf="error === 'CONTROLANT_API_ERROR_81'"
                           i18n="Token is invalid error@@errorPasswordTokenInvalid">No password reset is currently active for the
                            username provided.</p>
                        <p *ngIf="error === 'CONTROLANT_API_ERROR_82'"
                           i18n="Password doesn't meet requirements error@@errorPasswordStrength">Your password does not meet the
                            requirements imposed by your company. Please provide a password with a higher strength level.</p>
                        <p *ngIf="error === 'CONTROLANT_API_ERROR_83'"
                           i18n="Password reset has timed out error@@errorPasswordResetTimedOut">Your password reset window has
                            expired. Please reset your password again and use the link from the new e-mail.</p>
                        <p *ngIf="error === 'CONTROLANT_API_ERROR_84'"
                           i18n="Not enough time passed since last password change error@@errorPasswordDurationReject">Password
                            change failed. Not enough time has passed since the last password change, according to the requirements
                            imposed by your company.</p>
                        <p *ngIf="error === 'CONTROLANT_API_ERROR_85'"
                           i18n="Password doesn't meet reuse requirements error@@errorPasswordReuseReject">Password change failed.
                            The password doesn't meet password reuse requirements imposed by your company and therefore cannot be
                            reused at this moment.</p>

                        <p *ngIf="error === 'UNKNOWN_ERROR'" i18n="Unknown error@@errorUnknown">An unknown
                            error occurred. Please try again in a few minutes and contact <a
                                href="mailto:support@controlant.com">support</a> if this happens repeatedly.</p>
                    </div>
                </div>

            <form name="set-password-form" [formGroup]="setPasswordForm" (ngSubmit)="setPassword()" autocomplete="off">

                <div class="field">
                    <div class="label-help">
                        <label for="pw1" i18n="Label for New Password@@newPasswordLabel">New Password</label>
                        <span class="information" (click)="toggleInfo()"><fa-icon
                                [icon]="faQuestionCircle"></fa-icon></span>
                    </div>
                    <input
                        class="form-input-control"
                        [class.Error]="
                                setPasswordForm
                                    .get('pw1')
                                    .hasError('required') &&
                                setPasswordForm.get('pw1').touched
                            "
                        type="password"
                        formControlName="pw1"
                        id="pw1"
                        autocomplete="new-password"
                        required />
                    <div class="messageContainer">
                        <div class="password-strength-container" *ngIf="!setPasswordForm.get('pw1').hasError('required')">
                            <div class="form-input">
                                <span class="pw-strength-label">
                                    <span class="pw-strength level-0" *ngIf="pwStrengthLevel === 0"
                                        i18n="Unacceptable password strength label@@pwStrength0">Unacceptable</span>
                                    <span class="pw-strength level-1" *ngIf="pwStrengthLevel === 1"
                                        i18n="Low password strength label@@pwStrength1">Low strength</span>
                                    <span class="pw-strength level-2" *ngIf="pwStrengthLevel === 2"
                                        i18n="Fair password strength label@@pwStrength2">Fair strength</span>
                                    <span class="pw-strength level-3" *ngIf="pwStrengthLevel === 3"
                                        i18n="Good password strength label@@pwStrength3">Good strength</span>
                                    <span class="pw-strength level-4" *ngIf="pwStrengthLevel === 4"
                                        i18n="Excellent password strength label@@pwStrength4">Excellent strength</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field">
                    <label for="pw2" i18n="Label for Confirm new password@@confirmNewPasswordLabel">Confirm new
                        password</label>
                    <input
                        class="form-input-control"
                        [class.Error]="
                                setPasswordForm
                                    .get('pw2')
                                    .hasError('required') &&
                                setPasswordForm.get('pw2').touched
                            "
                        type="password"
                        formControlName="pw2"
                        id="pw2"
                        autocomplete="new-password"
                        required />
                </div>
                <div class="pw-strength-info" *ngIf="showInfo" click="toggleInfo()">
                    <div class="pw-strength-content" *ngIf="!!pwStrengthLevel">
                        <div style="overflow-y: scroll;">
                            <h3 i18n="Password Strength levels headline@@pwStrengthHeadline">Password strength levels</h3>
                            <p i18n="Password Strength levels introduction@@pwStrengthIntro">Each customer of Controlant can
                                set
                                a required password strength level for all their users. If you do not know your company's
                                policies, please ask a superior or contact Controlant support to find out.</p>
                            <div class="rule-groups">
                                <div class="rule-group">
                                    <span class="pw-strength level-0"
                                        i18n="Unacceptable password strength label@@pwStrength0">Unacceptable</span>
                                    <p i18n="Unacceptable password strength description@@pwStrength0Description">Passwords
                                        with
                                        less than 6 letters are unacceptable for all users.</p>
                                </div>
                                <div class="rule-group">
                                    <span class="pw-strength level-1" i18n="Low password strength label@@pwStrength1">Low
                                        strength</span>
                                    <div class="rule-defined">
                                        <p i18n="Low password strength description@@pwStrength1Description">Password has a
                                            minimum of 6 characters. </p>
                                        <span class="required-level" *ngIf="pwStrengthLevelRequired === 1"
                                            i18n="Required level label@@requiredLevelLabel">This is the minimum level
                                            required
                                            by your company.</span>
                                    </div>
                                </div>
                                <div class="rule-group">
                                    <span class="pw-strength level-2" i18n="Fair password strength label@@pwStrength2">Fair
                                        strength</span>
                                    <div class="rule-defined">
                                        <p i18n="Fair password strength description@@pwStrength2Description">Password has a
                                            minimum of 8 characters, including at least 1 lower-case and 1 upper-case
                                            character
                                            as well as either at least 1 digit or 1 special character<sup>1</sup>.</p>
                                        <span class="required-level" *ngIf="pwStrengthLevelRequired === 2"
                                            i18n="Required level label@@requiredLevelLabel">This is the minimum level
                                            required
                                            by your company.</span>
                                    </div>
                                </div>
                                <div class="rule-group">
                                    <span class="pw-strength level-3" i18n="Good password strength label@@pwStrength3">Good
                                        strength</span>
                                    <div class="rule-defined">
                                        <p i18n="Good password strength description@@pwStrength3Description">Password has a
                                            minimum of 10 characters, including at least 1 lower-case and 1 upper-case, 1
                                            digit
                                            and 1 special character<sup>1</sup>.</p>
                                        <span class="required-level" *ngIf="pwStrengthLevelRequired === 3"
                                            i18n="Required level label@@requiredLevelLabel">This is the minimum level
                                            required
                                            by your company.</span>
                                    </div>
                                </div>
                                <div class="rule-group">
                                    <span class="pw-strength level-4"
                                        i18n="Excellent password strength label@@pwStrength4">Excellent strength</span>
                                    <div class="rule-defined">
                                        <p i18n="Excellent password strength description@@pwStrength4Description">Password
                                            has a
                                            minimum of 12 characters, including at least 1 lower-case and 1 upper-case, 1
                                            digit
                                            and 1 special character<sup>1</sup>.</p>
                                        <span class="required-level" *ngIf="pwStrengthLevelRequired === 4"
                                            i18n="Required level label@@requiredLevelLabel"><br>This is the minimum level
                                            required by your company.</span>
                                    </div>
                                </div>
                            </div>

                            <p><small i18n="Special Characters footnote@@specialCharsFootnote"><sup>1</sup> Special
                                    characters
                                    are:
                                    <code>space ! @ # $ & * % < > ( ) " ' + ° ¨ ~ ` ’ ´ = | ? : ; , . [ ] ^ \ / {{ '{ }' }} _ - </code></small>
                            </p>
                        </div>
                        <button (click)="toggleInfo()">Close</button>
                    </div>
                    <div class="pw-strength-content" *ngIf="!pwStrengthLevel">
                        <h3 i18n="Company password policy headline@@pwPolicyHeadline">Company password policy</h3>
                        <div>
                            <div *ngIf="pwStrengthLevelRequired === 1">
                                <ul>
                                    <li>Minimum of 6 characters</li>
                                </ul>
                            </div>
                            <div *ngIf="pwStrengthLevelRequired === 2">
                                <ul>
                                    <li>Minimum of 8 characters</li>
                                    <li>Include lower-case character</li>
                                    <li>Include upper-case character</li>
                                    <li>Include 1 digit or 1 special character<sup>1</sup></li>
                                </ul>
                            </div>
                            <div *ngIf="pwStrengthLevelRequired === 3">
                                <ul>
                                    <li>Minimum of 10 characters</li>
                                    <li>Including lower-case character</li>
                                    <li>Including upper-case character</li>
                                    <li>Including digit</li>
                                    <li>Including special character<sup>1</sup></li>
                                </ul>
                            </div>
                            <div *ngIf="pwStrengthLevelRequired === 4">
                                <ul>
                                    <li>Minimum of 12 characters</li>
                                    <li>Including lower-case character</li>
                                    <li>Including upper-case character</li>
                                    <li>Including digit</li>
                                    <li>Including special character<sup>1</sup></li>
                                </ul>
                            </div>
                        </div>

                        <p><small i18n="Special Characters footnote@@specialCharsFootnote"><sup>1</sup> Special characters
                                are:
                                <code>space ! @ # $ & * % < > ( ) " ' + ° ¨ ~ ` ’ ´ = | ? : ; , . [ ] ^ \ / {{ '{ }' }} _ - </code></small>
                        </p>
                        <button (click)="toggleInfo()">Close</button>
                    </div>
                </div>

                <button [disabled]="busy">
                    <span i18n="Submit button label@@submitLabel">Set Password</span>
                </button>

            </form>


        </div>
        <!-- footer -->
        <div class="footerContainer">
            <div id="disclaimer">
                <p>
                    By logging in, you agree to our
                    <span (click)="showTerms = !showTerms" class="terms">
                        terms &amp; conditions</span
                    >.
                </p>
            </div>
            <div class="terms-modal" *ngIf="showTerms">
                <div class="terms-content">
                    <h3>Terms & conditions</h3>
                    <span class="close-dialog" (click)="showTerms = !showTerms"
                    ><fa-icon [icon]="faClose"></fa-icon
                    ></span>
                    <ul style="overflow-y: scroll">
                        <li>
                            He who wishes to lease or buy Controlant's system,
                            solutions and the service related commits to
                            undertake the terms and conditions stated in this
                            agreement and business terms.
                        </li>
                        <li>
                            Controlant.com
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://controlant.com/terms"
                            >Terms of Use</a
                            >,
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://controlant.com/privacy"
                            >Privacy Policy</a
                            >
                            and
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://controlant.com/cookies"
                            >Cookies and Tracking Notice</a
                            >
                            apply to your use of Supply Chain Monitoring web
                            interface.
                        </li>
                        <li>
                            Standard delivery time for service requests,
                            including requests for increase in number of
                            loggers, review of data, requests for calibration
                            and other comparable services, is no longer than 14
                            business days from the date of the request, unless
                            unpredictable complications arise. Standard delivery
                            time for requests on changes in registration in the
                            database system is no longer than 4 business days
                            unless unpredictable complications arise. Customer
                            is aware that delivery time can vary depending on
                            different shipment methods.
                        </li>
                        <li>
                            Customers are obliged to treat all leased equipment
                            belonging to Controlant properly, and are liable for
                            any damage that occurs and cannot be traced to
                            normal dissolution, as well as for any equipment
                            that is lost while in their possession. Use of
                            equipment shall be in accordance with the guidelines
                            following the equipment.
                        </li>
                        <li>
                            The users of Controlant's solutions are liable for
                            all valuables that are being monitored by utilizing
                            Controlant solutions.
                        </li>
                        <li>
                            Controlant seeks to maximize security and efficiency
                            of real time monitoring, but the Customer of the
                            service acknowledges that loss of data is possible
                            due to power failure, loss of internet connection,
                            equipment failure or of other unpredictable causes.
                        </li>
                        <li>
                            Controlant will try to solve problems that can occur
                            including e.g. range issues, implementation problems
                            etc. with the equipment and methods the company
                            possesses. The Customer still acknowledges that
                            situations can occur where conventional methods are
                            not enough without the purchase of additional
                            equipment or service.
                        </li>
                        <li>
                            Controlant is not liable or responsible for any
                            damage or cost that might be caused by late delivery
                            of the leased equipment when delivery is delayed
                            because of circumstances not concerning the company,
                            e.g. due to delays which might occur from producer
                            or possible delays at transportation companies.
                        </li>
                        <li>
                            The Customer shall examine the leased equipment
                            carefully upon delivery and notify Controlant if
                            there are any comments on the condition of the
                            leased equipment.
                        </li>
                        <li>
                            Controlant is not liable or responsible for any
                            consequential damages or costs that might occur from
                            damages on the Customer's valuables or the valuables
                            of others if this is caused by a failure in the
                            leased equipment or the wrong usage of the
                            equipment.
                        </li>
                        <li>
                            The leased equipment shall be delivered in good
                            condition when returned and not damaged considering
                            normal usage during the agreement period, otherwise
                            charges for damages become effective according to
                            the terms of the agreement.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
